import { Filter } from "@/v2/entities/explore/Explore.filter";
import { useExploreCount } from "@/v2/entities/explore/Explore.api";
import {
  ExploreInteractionType,
  exploreInteractionTypeToLabel,
} from "@/v2/entities/explore/Explore.model";
import { Skeleton } from "@/components/ui/skeleton";

interface ExploreCountProps {
  source?: ExploreInteractionType;
  filter?: Filter;
  className?: string;
}

export function ExploreCount({
  source,
  filter,
  className = "mx-auto aspect-square  flex items-center justify-center flex-col",
}: ExploreCountProps) {
  const { data, isLoading } = useExploreCount({
    source,
    filter,
  });

  return (
    <div className={className}>
      <div className="text-2xl leading-none font-bold sm:text-xl text-muted-foreground">
        {exploreInteractionTypeToLabel[source ?? "tickets"].plural}
      </div>

      {isLoading ? (
        <Skeleton className="w-32 h-12" />
      ) : (
        <div className="text-5xl leading-none font-bold sm:text-5xl">
          {data?.count ? data.count.toLocaleString() : "-"}
        </div>
      )}
    </div>
  );
}
